import React from 'react';
import Logo from './Logo';
import { Logo as HCgovLogo } from '../Logo';
import { getLanguage } from '@cmsgov/design-system';
var LogosRow = function LogosRow(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: "ds-l-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "hc-c-footer__logo-row"
  }, /*#__PURE__*/React.createElement(Logo, {
    href: getLanguage() === 'es' ? 'https://www.cuidadodesalud.gov' : 'https://www.healthcare.gov'
  }, /*#__PURE__*/React.createElement(HCgovLogo, {
    titleId: "hc-c-footer__logo-title"
  })), /*#__PURE__*/React.createElement("div", {
    className: "hc-c-footer__disclaimer"
  }, getLanguage() === 'en' && /*#__PURE__*/React.createElement("p", null, "Health Insurance Marketplace", /*#__PURE__*/React.createElement("sup", null, "\xAE"), " is a registered trademark of the Department of Health & Human Services."), /*#__PURE__*/React.createElement("p", {
    dangerouslySetInnerHTML: {
      __html: props.t('footer.disclaimer')
    }
  }))));
};
export default LogosRow;